/* eslint-disable @typescript-eslint/class-name-casing */
export const hoverFocusActiveStyle = (styles) => {
    return {
        ':hover': styles,
        ':focus': styles,
        ':active': styles,
    };
};
export const hoverFocusActiveStyleOfChild = (child, styles) => {
    return {
        [`:hover .${child}`]: styles,
        [`:focus .${child}`]: styles,
        [`:active .${child}`]: styles,
    };
};
/**
 * transition の duration と timing-function をアプリ内で共通化
 */
export const transition = (property = 'all') => {
    return `${property} .6s ease`;
};
class _StyleMixin {
    constructor(base) {
        // tslint:disable-next-line:variable-name
        Object.defineProperty(this, "_styles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._styles = base;
        Object.defineProperty(this, '_styles', {
            enumerable: false,
        });
    }
    mouseReact(props) {
        const reactStyles = {
            ':hover': props,
            ':focus': props,
            ':active': props,
        };
        this._styles = Object.assign(this._styles, reactStyles);
        this.updateProps();
        return this;
    }
    mouseReactOfChild(child, props) {
        const reactStyles = {
            [`:hover .${child}`]: props,
            [`:focus .${child}`]: props,
            [`:active .${child}`]: props,
        };
        this._styles = Object.assign(this._styles, reactStyles);
        this.updateProps();
        return this;
    }
    updateProps() {
        // tslint:disable-next-line:forin
        for (const k in this._styles) {
            Object.defineProperty(this, k, {
                get: () => this._styles[k],
                enumerable: true,
            });
        }
    }
}
export function StyleMixin(base) {
    return new _StyleMixin(base);
}
